import { BorderGridContainer, GridBox } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';
import styled from 'styled-components';

import Banner from '../../../elements/banner';
import constants from '../../../ahm-constants';
import CONTENT from './content';
import Head from '../../../../utils/head';
import InsuranceSection from '../components/section';
import RedirectAdapter from '../../../utils/redirect-adapter';

type LifeInsuranceContactUsPageProps = {
  insuranceType: string;
};

const StyledInsuranceSection = styled(InsuranceSection)`
  padding-bottom: 8rem;
`;

const FULL_WIDTH_COLS = 12;

const LifeInsuranceContactUsPage = ({ insuranceType }: LifeInsuranceContactUsPageProps) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ car: ({ insuranceType }: { insuranceType: string; }) => { meta: { title: string; description: string; }; banner: { title: string; preHeading: string; }; body: Element; }; home: ({ insuranceType }: { insuranceType: string; }) => { ...; }; 'income-protection': () => { ...; }; life: () => { ...; }; }'.
  const content = CONTENT?.[insuranceType]({ insuranceType });

  if (isEmpty(content)) {
    return <RedirectAdapter to={constants.URLS.SALES.ERROR_404} />;
  }

  const meta = content?.meta;

  return (
    <>
      <Head titleTemplate={`%s - ${insuranceType} insurance - ahm`}>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Head>
      <BorderGridContainer hideBorderTop>
        {content?.banner && <Banner {...content.banner} />}
        <GridBox padding="0">
          <StyledInsuranceSection dfContentCols={FULL_WIDTH_COLS}>
            {content?.body && content.body}
          </StyledInsuranceSection>
        </GridBox>
      </BorderGridContainer>
    </>
  );
};

export default LifeInsuranceContactUsPage;
